var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4"},[_c('app-text',{staticClass:"primary--text",attrs:{"category":"text-xlarge"}},[_vm._v("SETTINGS")]),_c('router-link',{attrs:{"to":"/settings/lookups"}},[_vm._v("Lookups")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }